<template>
  <div v-if="showFooter" class="layout-footer mt15">
    <div class="layout-footer-warp">
      <div v-if="version.status === -1" class="layout-footer-copyright">
        Copyright {{ version.year }}
        <a
          v-if="version.url"
          :href="version.url"
          target="_blank"
          rel="noopener noreferrer"
        >{{ version.version }}</a>
        <span v-else>{{ version.version }}</span>
      </div>
      <div v-else-if="version.Copyright" class="layout-footer-copyright">
        {{ version.Copyright }}
      </div>
      <div v-else-if="beianSn" class="layout-footer-copyright">{{ beianSn }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import Cookies from 'js-cookie';
import { getVersion } from '@/api/user';
import useCrmebThemeConfigStore from '@/store/modules/themeConfig';
import { isCrmebStandaloneRoute } from '@/config/crmeb-standalone-routes';

const route = useRoute();
const themeStore = useCrmebThemeConfigStore();

const beianSn = ref('');
const version = reactive<{
  status?: number;
  year?: string;
  version?: string;
  url?: string;
  Copyright?: string;
}>({});

const showFooter = computed(() => {
  if (!themeStore.themeConfig.isFooter) return false;
  if (route.meta?.fullScreen) return false;
  if (isCrmebStandaloneRoute(route.name)) return false;
  return true;
});

onMounted(() => {
  try {
    const raw = Cookies.get('MerInfo');
    if (raw) {
      const info = JSON.parse(raw);
      beianSn.value = info.beianSn ?? '';
    }
  } catch {
    /* ignore */
  }
  getVersion()
    .then((res: any) => {
      const data = res?.data ?? res;
      Object.assign(version, data?.version ? data : data);
      if (data?.copyright) version.Copyright = data.copyright;
      if (data?.sys_open_version != null) {
        /* 对齐 EB openVersion，仅展示用 */
      }
    })
    .catch(() => {
      /* 无版权接口时仅展示备案号 */
    });
});
</script>

<style scoped lang="scss">
.layout-footer {
  width: 100%;
  display: flex;
  &-warp {
    margin: auto;
    color: var(--prev-color-text-secondary, #909399);
    text-align: center;
    font-size: 12px;
    padding: 8px 0 16px;
  }
  a {
    color: inherit;
    margin-left: 4px;
  }
}
</style>
